import React, { useEffect, useRef, useState } from 'react';

const CategoryNav = ({ categories, activeCategory, onCategoryChange }) => {
    const navRef = useRef(null);
    const [canScrollLeft, setCanScrollLeft] = useState(false);
    const [canScrollRight, setCanScrollRight] = useState(false);

    const checkScroll = () => {
        if (navRef.current) {
            const { scrollLeft, scrollWidth, clientWidth } = navRef.current;
            setCanScrollLeft(scrollLeft > 5);
            setCanScrollRight(scrollLeft + clientWidth < scrollWidth - 5);
        }
    };

    useEffect(() => {
        checkScroll();
        window.addEventListener('resize', checkScroll);
        return () => window.removeEventListener('resize', checkScroll);
    }, [categories]);

    useEffect(() => {
        if (activeCategory && navRef.current) {
            const activeButton = navRef.current.querySelector('.category-btn.active');
            if (activeButton) {
                const containerWidth = navRef.current.clientWidth;
                const buttonLeft = activeButton.offsetLeft;
                const buttonWidth = activeButton.clientWidth;
                
                const scrollPos = buttonLeft - (containerWidth / 2) + (buttonWidth / 2);
                
                navRef.current.scrollTo({
                    left: scrollPos,
                    behavior: 'smooth'
                });
            }
        }
    }, [activeCategory]);

    const scrollByAmount = (amount) => {
        if (navRef.current) {
            navRef.current.scrollBy({ left: amount, behavior: 'smooth' });
        }
    };

    return (
        <div className="category-nav-wrapper">
            {canScrollLeft && (
                <button className="scroll-arrow left" onClick={() => scrollByAmount(-200)}>
                    <i className="fas fa-chevron-left"></i>
                </button>
            )}
            <nav className="category-nav" ref={navRef} onScroll={checkScroll}>
                <ul id="category-list">
                    {categories.map((category) => (
                        <li key={category}>
                            <button
                                className={`category-btn ${activeCategory === category ? 'active' : ''}`}
                                onClick={() => {
                                    onCategoryChange(category);
                                    const element = document.getElementById(`category-${category.replace(/\s+/g, '-')}`);
                                    if (element) {
                                        element.scrollIntoView({ behavior: 'smooth' });
                                    }
                                }}
                            >
                                {category}
                            </button>
                        </li>
                    ))}
                </ul>
            </nav>
            {canScrollRight && (
                <button className="scroll-arrow right" onClick={() => scrollByAmount(200)}>
                    <i className="fas fa-chevron-right"></i>
                </button>
            )}
        </div>
    );
};

export default CategoryNav;